import { FC, useState, useEffect } from "react";
import { Box, OutlinedInput } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";

interface SearchInputProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  timeout?: number;
  isWide?: boolean;
}

export const SearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search",
  timeout = 1000,
  isWide,
}) => {
  const classes = useStyles();
  const [query, setQuery] = useState(value || "");

  useEffect(() => {
    const timeoutId = setTimeout(() => onChange(query), timeout);
    return () => clearTimeout(timeoutId);
  }, [onChange, timeout, query]);

  return (
    <Box className={`${classes.search} ${isWide ? classes.wideWidth : classes.shortWidth}`}>
      <Box className={classes.searchIcon} color="primary">
        <SearchIcon />
      </Box>
      {query && (
        <Box className={classes.closeIcon} color="primary" onClick={() => setQuery("")}>
          <Close />
        </Box>
      )}
      <OutlinedInput
        placeholder={placeholder}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
  },
  wideWidth: {
    width: 480,
  },
  shortWidth: {
    width: 280,
  },
  searchIcon: {
    padding: theme.spacing(0, 1.5),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
    color: "#5F6164",
  },
  closeIcon: {
    cursor: "pointer",
    padding: theme.spacing(0, 1.5),
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    color: "#5F6164",
    right: 0,
  },
  inputRoot: {
    width: "100%",
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1.2, 6),
    width: "100%",
  },
  "@media (max-width: 840px)": {
    wideWidth: {
      width: "100%",
    },
    shortWidth: {
      width: "100%",
    },
    inputRoot: {
      width: "100%",
    },
  },
}));
